import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../assets/styles/Memberships.css";

const memberships = [
  {
    name: "Starter Plan",
    price: "$1,000",
    period: "/ month",
  },
  {
    name: "Corporate Plan",
    price: "$1,800",
    period: "/ month",
  },
  {
    name: "Custom Plan",
    price: "$3,000",
    period: "/ month",
  },
];

const Memberships = () => {
  const navigate = useNavigate();

  const handleViewDetails = () => {
    // Navigate to cloud membership page
    navigate('/cloudMembership');
  };

  return (
    <section className="memberships-section">
      <Container>
        <h2 className="section-title">Membership Plans</h2>
        <p className="section-description">
        Harness seamless collaboration with our cloud memberships, built to equip virtual teams with scalable, efficient solutions that boost productivity and connectivity.
        </p>
        <Row className="g-4">
          {memberships.map((plan, index) => (
            <Col md={4} key={index}>
              <Card className="membership-card">
                <Card.Body>
                  <h4 className="membership-name">{plan.name}</h4>
                  <h2 className="membership-price">
                    {plan.price} <span className="membership-period">{plan.period}</span>
                  </h2>
                  <button 
                    className="view-details mt-2" 
                    onClick={handleViewDetails}
                  >
                    <span>View Details</span>
                  </button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Memberships;
